export const news = [
  {
    id: 'n1',
    title: '年度影视颁奖礼落幕 各大奖项花落谁家',
    type: 'news',
    category: 'news',
    categoryName: '娱乐资讯',
    newsTag: '活动报道',
    tags: ['颁奖礼', '活动', '年度'],
    cover:
      'https://readdy.ai/api/search-image?query=Glamorous%20awards%20ceremony%20stage%20with%20golden%20trophies%20and%20elegant%20red%20carpet%20lighting%20in%20dark%20moody%20tones%20with%20warm%20amber%20accents%2C%20cinematic%20formal%20atmosphere%2C%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=600&seq=cover-n1&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Elegant%20golden%20award%20trophy%20on%20a%20dark%20podium%20under%20dramatic%20spotlight%20with%20warm%20amber%20tones%2C%20cinematic%20ceremonial%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20editorial%20aesthetic&width=900&height=600&seq=gal-n1-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Red%20carpet%20entrance%20at%20a%20grand%20theater%20at%20night%20with%20flash%20lights%20and%20dark%20moody%20tones%20with%20warm%20accents%2C%20cinematic%20glamour%20aesthetic%2C%20high%20detail&width=900&height=600&seq=gal-n1-2&orientation=landscape',
    ],
    excerpt:
      '为期两天的年度影视颁奖礼正式落幕，多个重要奖项归属揭晓，实力派演员与传统制作团队成为本届最大赢家。',
    content: [
      '备受关注的年度影视颁奖礼于昨晚正式落下帷幕。为期两天的活动汇聚了众多影视从业者，多个重要奖项的归属也在颁奖之夜逐一揭晓。',
      '本届评选延续了对作品品质与演员实力的看重，多部口碑剧集与电影获得提名，最终由一批实力派演员与传统制作团队斩获大奖项，被媒体评价为本届的"最大赢家"。',
      '在剧集单元，一部聚焦现实题材的作品拿下最佳剧集，其主演凭借细腻的表演获得最佳女主角。评审团在致辞中表示，该作品用真诚的叙事打动了观众，是年度不可忽视的佳作。',
      '电影单元方面，一部关注普通人生活的文艺片摘得最佳影片，导演在领奖时感谢了全体主创，称"好故事永远值得被讲述"。现场气氛几度被推上高潮。',
      '除颁奖环节外，本届活动还设置了行业论坛，多位制片人、编剧与演员围绕"内容为本"展开讨论，呼吁行业回归创作本身，减少对流量的过度依赖。',
      '活动主办方透露，明年的颁奖礼将进一步优化评选机制，增加观众参与环节。整场典礼的完整回放已在各大平台上线，感兴趣的观众可前往观看。',
    ],
    author: '本站编辑',
    source: '综合报道',
    publishTime: '2026-10-13T10:00:00',
    views: 38900,
    likes: 1520,
    isHot: true,
  },
  {
    id: 'n2',
    title: '影视行业年度报告发布 剧集市场迎来新变化',
    type: 'news',
    category: 'news',
    categoryName: '娱乐资讯',
    newsTag: '娱乐圈新闻',
    tags: ['行业报告', '剧集', '市场'],
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20glass%20office%20tower%20reflecting%20city%20lights%20at%20night%20in%20dark%20moody%20tones%20with%20warm%20amber%20accents%2C%20cinematic%20corporate%20editorial%20aesthetic%2C%20high%20detail&width=800&height=600&seq=cover-n2&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20rising%20bar%20charts%20and%20data%20visualization%20glowing%20on%20a%20dark%20screen%20in%20red%20and%20amber%20tones%2C%20cinematic%20business%20aesthetic%2C%20high%20detail%2C%20abstract&width=900&height=600&seq=gal-n2-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Screening%20room%20with%20rows%20of%20empty%20seats%20and%20a%20glowing%20projector%20beam%20in%20dark%20moody%20tones%20with%20warm%20accents%2C%20cinematic%20industry%20atmosphere%2C%20high%20detail&width=900&height=600&seq=gal-n2-2&orientation=landscape',
    ],
    excerpt:
      '最新发布的影视行业年度报告显示，短剧与精品剧集双线并进，观众对内容质量的要求持续提升，行业格局正在悄然重塑。',
    content: [
      '近日，一份关于影视行业的年度报告正式发布，系统梳理了过去一年剧集与电影市场的整体表现。报告指出，行业正处在一个结构性调整的阶段，内容质量成为决定成败的关键因素。',
      '报告显示，短剧市场继续保持高速增长，成为不少制作公司新的发力方向；与此同时，精品长剧也凭借扎实的剧本与制作，在口碑与播放数据上双双走高，"长短并行"的格局逐渐清晰。',
      '在观众偏好方面，报告提到，现实题材与类型创新的作品更受青睐，观众对"注水剧情"与"套路化表达"的容忍度明显下降，这也在倒逼制作方提升内容水准。',
      '值得注意的是，演员生态同样发生变化。报告认为，拥有扎实演技的演员正获得更多机会，单纯依赖流量号召力的模式面临挑战，行业对"演员的专业性"提出了更高要求。',
      '多位业内人士在解读报告时表示，未来一年，平台与制作方之间的合作将更加注重长期价值，盲目追求短期热度的项目会逐步减少。',
      '报告最后建议，从业者应更加关注观众的长期需求，用真诚的内容赢得市场。完整报告已在相关平台公开，供行业内外参考。',
    ],
    author: '本站编辑',
    source: '行业观察',
    publishTime: '2026-10-11T14:20:00',
    views: 27600,
    likes: 980,
    isHot: false,
  },
  {
    id: 'n3',
    title: '经典IP翻拍引发热议 原著粉与剧粉隔空开战',
    type: 'news',
    category: 'news',
    categoryName: '娱乐资讯',
    newsTag: '影视花边',
    tags: ['翻拍', 'IP', '原著', '热议'],
    cover:
      'https://readdy.ai/api/search-image?query=Stack%20of%20classic%20books%20next%20to%20a%20glowing%20screen%20in%20dark%20moody%20tones%20with%20warm%20amber%20accents%2C%20cinematic%20literary%20versus%20film%20symbolism%2C%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=600&seq=cover-n3&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Vintage%20hardcover%20novel%20open%20on%20a%20dark%20wooden%20desk%20under%20a%20warm%20reading%20lamp%20in%20moody%20low%20key%20tones%2C%20cinematic%20nostalgic%20aesthetic%2C%20high%20detail&width=900&height=600&seq=gal-n3-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20television%20screen%20glowing%20in%20a%20dark%20room%20with%20red%20and%20amber%20ambient%20reflections%2C%20cinematic%20home%20cinema%20mood%2C%20high%20detail&width=900&height=600&seq=gal-n3-2&orientation=landscape',
    ],
    excerpt:
      '一部经典IP宣布翻拍后引发巨大讨论，原著粉丝与剧集支持者在网络上展开争论，争议焦点集中在选角与改编尺度上。',
    content: [
      '一部拥有庞大书迷基础的经典IP近日宣布启动翻拍，官方同时公布了主创阵容与概念海报，消息一出便迅速引爆网络讨论。',
      '争议的焦点首先集中在选角上。不少原著粉丝认为，主角人选与书中人物的气质存在差距，担心翻拍会"毁了经典"；而剧集支持者则表示，影视改编本就不同于文字，应给予新版本充分的创作空间。',
      '其次，改编尺度也成为讨论的热点。原著粉丝希望剧集能忠于情节与人物内核，制作方则透露会在保留精髓的基础上进行适当调整，以适应影视叙事节奏，双方各执一词。',
      '值得一提的是，该IP此前已有多个改编版本，口碑褒贬不一。有观众翻出旧版对比，感慨"每一代人都有自己心中的经典"，认为新版本不妨以全新的视角来看待。',
      '面对争议，制片方通过官方账号回应，称理解书迷的心情，团队会在尊重原著的前提下用心打磨，并邀请观众等待成品再作评价。',
      '目前，该剧已进入前期筹备阶段，预计将于明年开机。翻拍能否成功，最终仍要由作品本身说话。',
    ],
    author: '本站编辑',
    source: '综合报道',
    publishTime: '2026-10-09T17:40:00',
    views: 31200,
    likes: 1240,
    isHot: false,
  },
  {
    id: 'n4',
    title: '音乐颁奖典礼入围名单公布 新生代歌手强势入围',
    type: 'news',
    category: 'news',
    categoryName: '娱乐资讯',
    newsTag: '活动报道',
    tags: ['音乐', '颁奖', '新生代'],
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20concert%20stage%20with%20dramatic%20lighting%20and%20a%20microphone%20in%20the%20spotlight%2C%20dark%20moody%20tones%20with%20vibrant%20red%20and%20amber%20accents%2C%20cinematic%20music%20award%20atmosphere%2C%20editorial%20aesthetic%2C%20high%20detail&width=800&height=600&seq=cover-n4&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Sleek%20wireless%20headphones%20and%20a%20glowing%20turntable%20on%20a%20dark%20surface%20with%20red%20and%20amber%20accents%2C%20cinematic%20music%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=900&height=600&seq=gal-n4-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Crowd%20silhouettes%20with%20glowing%20phone%20lights%20at%20a%20dark%20concert%20in%20moody%20tones%20with%20warm%20accents%2C%20cinematic%20live%20music%20atmosphere%2C%20high%20detail&width=900&height=600&seq=gal-n4-2&orientation=landscape',
    ],
    excerpt:
      '年度音乐颁奖典礼入围名单正式公布，多位新生代歌手强势入围，与资深前辈同台竞争，引发乐迷广泛期待。',
    content: [
      '年度音乐颁奖典礼的入围名单昨日正式公布，涵盖年度专辑、年度歌曲、最佳新人等多个重量级奖项，引发乐迷热烈讨论。',
      '本次名单最大的看点，是新生代歌手的强势崛起。多位出道不久的年轻歌手凭借作品的传唱度与口碑入围重要奖项，将与资深前辈同台竞争，被视为乐坛新老交替的信号。',
      '从入围情况看，兼具创作能力与舞台表现的歌手获得更多青睐。评审方表示，本次评选更加看重作品的原创性与长期影响力，而非单纯的短期热度。',
      '在榜单公布后，多位入围歌手在社交平台表达感谢，表示会以更好的作品回馈听众。粉丝们也纷纷为偶像拉票，希望心仪的歌手能最终获奖。',
      '主办方透露，本届颁奖礼将融入更多现场表演环节，部分入围歌手将在舞台带来新歌首秀，力求为观众呈现一场兼具音乐性与观赏性的晚会。',
      '颁奖典礼的具体举行时间与举办地点将于近期公布，本站将持续关注后续动态。',
    ],
    author: '本站编辑',
    source: '综合报道',
    publishTime: '2026-10-08T09:10:00',
    views: 24100,
    likes: 890,
    isHot: false,
  },
  {
    id: 'n5',
    title: '多位艺人官宣新代言 商业价值榜单出炉',
    type: 'news',
    category: 'news',
    categoryName: '娱乐资讯',
    newsTag: '娱乐圈新闻',
    tags: ['代言', '商业价值', '榜单'],
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20luxury%20product%20display%20with%20soft%20studio%20lighting%20in%20dark%20moody%20tones%20with%20warm%20amber%20accents%2C%20premium%20commercial%20photography%20aesthetic%2C%20minimal%20composition%2C%20high%20detail&width=800&height=600&seq=cover-n5&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Brand%20collaboration%20concept%20with%20a%20silhouette%20against%20a%20product%20display%20in%20dark%20moody%20tones%20with%20warm%20accent%20light%2C%20cinematic%20commercial%20aesthetic%2C%20high%20detail&width=900&height=600&seq=gal-n5-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20flat%20lay%20on%20a%20dark%20marble%20surface%20with%20dramatic%20side%20lighting%20and%20amber%20tones%2C%20premium%20editorial%20aesthetic%2C%20high%20detail&width=900&height=600&seq=gal-n5-2&orientation=landscape',
    ],
    excerpt:
      '近期多位艺人陆续官宣新代言，一份最新的商业价值榜单同步出炉，头部演员与实力歌手依旧稳居前列。',
    content: [
      '进入年末，娱乐圈迎来一波代言官宣高峰。近日，多位演员与歌手陆续官宣新的品牌合作，覆盖美妆、服饰、数码等多个领域，引发市场关注。',
      '与此同时，一份最新的艺人商业价值榜单同步出炉。从结果看，兼具作品口碑与稳定曝光的头部演员、实力歌手依旧稳居前列，商业合作的类型也呈现出向高端品牌集中的趋势。',
      '业内分析认为，品牌在选择代言人时，正从"唯流量论"转向更综合的考量，除了粉丝规模，艺人形象、公众口碑与作品稳定性都被纳入评估范围。',
      '值得关注的是，一些凭借扎实专业能力走红的艺人，虽然曝光频率不高，却因其正面形象获得多个品牌的长期青睐，成为商业合作中的"稳健选择"。',
      '也有观点提醒，代言数量并非越多越好，过于密集的商业合作可能会稀释艺人的专业形象，如何在商业价值与作品质量之间取得平衡，是每位艺人需要面对的课题。',
      '随着年末营销季的到来，预计还将有更多品牌合作陆续公布，本站将持续整理相关动态。',
    ],
    author: '本站编辑',
    source: '商业观察',
    publishTime: '2026-10-06T13:50:00',
    views: 19800,
    likes: 720,
    isHot: false,
  },
  {
    id: 'n6',
    title: '跨界综艺即将上线 嘉宾阵容曝光引期待',
    type: 'news',
    category: 'news',
    categoryName: '娱乐资讯',
    newsTag: '影视花边',
    tags: ['综艺', '阵容', '跨界'],
    cover:
      'https://readdy.ai/api/search-image?query=Colorful%20modern%20variety%20show%20stage%20with%20neon%20geometric%20shapes%20in%20dark%20moody%20tones%20with%20vibrant%20red%20and%20amber%20accents%2C%20cinematic%20entertainment%20poster%20aesthetic%2C%20high%20detail&width=800&height=600&seq=cover-n6&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Empty%20modern%20talk%20show%20set%20with%20colorful%20lighting%20in%20dark%20moody%20tones%20and%20warm%20accents%2C%20cinematic%20broadcast%20aesthetic%2C%20high%20detail&width=900&height=600&seq=gal-n6-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Director%20clapperboard%20and%20colorful%20props%20on%20a%20dark%20table%20with%20dramatic%20lighting%20and%20amber%20tones%2C%20cinematic%20behind%20the%20scenes%20mood%2C%20high%20detail&width=900&height=600&seq=gal-n6-2&orientation=landscape',
    ],
    excerpt:
      '一档主打跨界挑战的全新综艺即将上线，官方公布的嘉宾阵容横跨演员、歌手与运动员，尚未开播便已收获大量关注。',
    content: [
      '一档主打跨界挑战的全新综艺节目即将与观众见面。节目组近日公布了首季嘉宾阵容，横跨演员、歌手、运动员等多个领域，尚未开播便已在社交平台收获大量关注。',
      '据介绍，节目将以"突破舒适圈"为核心概念，邀请不同领域的嘉宾参与彼此并不擅长的挑战项目，通过团队协作与个人成长，呈现真实而有趣的故事。',
      '公布的阵容中，既有观众熟悉的实力派演员，也有正当红的年轻歌手，还有曾在赛场上拼搏的运动员。多样化的组合让不少网友直呼"期待这种奇妙的化学反应"。',
      '节目组表示，节目在赛制设计上更强调真实与温度，避免刻意制造冲突，希望通过嘉宾之间的真诚互动，传递积极向上的氛围。',
      '在先导预告片发布后，相关话题迅速登上热搜，网友纷纷在评论区猜测各组搭档的表现。有评论认为，若节目能保持真实感，有望成为本季的黑马综艺。',
      '该节目将于近期正式开播，具体播出时间以官方发布为准。本站将持续关注节目动态。',
    ],
    author: '本站编辑',
    source: '综合报道',
    publishTime: '2026-10-04T10:30:00',
    views: 21500,
    likes: 810,
    isHot: false,
  },
];